// FILE: /pages/_app.js
import '../styles/globals.css';
import AdminLayout from '../components/AdminLayout';
import { useRouter } from 'next/router';

// This is the main entry point for your application.
function MyApp({ Component, pageProps }) {
  const router = useRouter();

  // Define pages that should NOT have the admin layout (like the login page).
  const publicPages = ['/login', '/admin-reset'];

  // If the current page is public, render it without the layout.
  if (publicPages.includes(router.pathname)) {
    return <Component {...pageProps} />;
  }

  // Otherwise, wrap the page in the consistent AdminLayout.
  return (
    <AdminLayout>
      <Component {...pageProps} />
    </AdminLayout>
  );
}

export default MyApp;
